import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type EditEmployeeRateMutationVariables = Types.Exact<{
  input: Types.EditEmployeeRateCommand;
}>;


export type EditEmployeeRateMutation = { __typename?: 'MutationModel', employeeRates: { __typename?: 'EmployeeRatesMutationModel', editRate: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const EditEmployeeRateDocument = gql`
    mutation EditEmployeeRate($input: EditEmployeeRateCommand!) {
  employeeRates {
    editRate(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type EditEmployeeRateMutationFn = Apollo.MutationFunction<EditEmployeeRateMutation, EditEmployeeRateMutationVariables>;

/**
 * __useEditEmployeeRateMutation__
 *
 * To run a mutation, you first call `useEditEmployeeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEmployeeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEmployeeRateMutation, { data, loading, error }] = useEditEmployeeRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEmployeeRateMutation(baseOptions?: Apollo.MutationHookOptions<EditEmployeeRateMutation, EditEmployeeRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEmployeeRateMutation, EditEmployeeRateMutationVariables>(EditEmployeeRateDocument, options);
      }
export type EditEmployeeRateMutationHookResult = ReturnType<typeof useEditEmployeeRateMutation>;
export type EditEmployeeRateMutationResult = Apollo.MutationResult<EditEmployeeRateMutation>;
export type EditEmployeeRateMutationOptions = Apollo.BaseMutationOptions<EditEmployeeRateMutation, EditEmployeeRateMutationVariables>;